// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__DMpDX","InputContainer":"Form_InputContainer__lqYSP","FormError":"Form_FormError__VeTQd","Success":"Form_Success__5f2f6"};